/* eslint-disable */
import { ERROR_ACTION , SET_ADVERTISEMENT_DETAILS_AND_CANDIDATE_LIST, SET_SHOW_VERIFY_DOCUMENT_TABLE ,SET_SHOW_UPDATE_APPROVE_DOC_MODAL,SET_VIEW_EXPERIENCE_AND_QUALIFICATION_MODAL,SET_SHOW_APPROVE_EXPERIENCE_AND_QUALIFICATION_DOC_MODAL,SET_SCRUTINY_REPORT_DETAILS,SET_GET_POST_NAMES_DATA,SET_SHOW_SCRUTINY_REPORT_DETAILS,SET_GET_ALL_ACTIVE_ADVERTISEMENT,
    SET_SHOW_APPROVE_DOC_MODAL, SET_CANDIDATES_BY_ADVERTISEMENT, SET_CANCEL_REJECT_APPLICATIONDATA_BY_ADVERTISEMENT,SET_CANCEL_REJECT_APPLICATIONS_LIST, SET_DOCUMENTLIST_BY_CANDIDATE,SET_PROFILE_INFO_BY_CANDIDATE, SET_VIEW_DOC_MODAL, SET_USER_BY_ADVERTISEMENT, SET_APPROVAL_DOC_LIST, SET_EXPERIENCE_AND_QUALIFICATION_APPROVAL_ACTION_HISTORY,
    SET_ADVERTISEMENT_DETAILS, SET_APPROVAL_ACTION_HISTORY, ADVERTISEMENT_LIST_FOR_DOCUMENT_APPROVAL,SET_ADVERTISEMENT_DETAILS_AND_DOC_APPROVAL_LIST,SET_PROFILE_INFO_DISPLAY,SET_PROFILE_CREATION_LOOKUPS,SET_QUALIFICATION_TYPES,SET_APPLICATION_DETAILS,SET_PROFILE_DETAILS, GET_ADDITIONAL_QUESTIONS_DATA, GET_ADDITIONAL_ANSWERS_DATA, SET_YEAR} from "../../common/constants/ActionTypes";

const initialState = {
    errorMessage: "",
    advertisementDetailsAndCandidateList :false,
    showVerifyDocumentTable : false,
    showApproveDocumentModal : false,
    showUpdateApproveDocumentModal: false,
    showCancelRejectApplications: false,
    candidatesDetailsList : [],
    documentListByCandidate : [],
    viewDocumentFlag : false,
    viewExperienceAndQualificationDocumentFlag : false,
    showExperienceAndQualificationApproveDocumentModal:false,
    userListForApproval : [],
    profileInfoByCandidate: [],
    approvalDocumentList : [],
    advertisementDetails : [],
    canceRejectApplicationList:[],
    approvalActionHistoryList:[],
    advtListForDocApproval:[],
    showApprovalDocList: false,
    profileInfo:null,
    profileCreationAllLookupData: [],
    qualificationTypes : [],
    applicationDetails:{},
    profileDetails:{},
    additionalQuestions: [],
    additionalAnswers: [],
    scrutinyReportData : [],
    postNamesData: [],
    showDocumentScrutinyTable : false,
    experienceAndQualificationApprovalActionHistoryList:[],
    allActiveAdvertisements:[],
    yearList:[],
}

export default function commonReducer(state = initialState, action) {
   switch(action.type) {
       case ERROR_ACTION:
           return {
               ...state,
               errorMessage: action.payload
           }
       case SET_ADVERTISEMENT_DETAILS_AND_CANDIDATE_LIST:
               return {
                   ...state,
                   advertisementDetailsAndCandidateList: action.payload
               }
        case SET_SHOW_VERIFY_DOCUMENT_TABLE:
            return {
                ...state,
                showVerifyDocumentTable : action.payload
            }  
        case SET_SHOW_APPROVE_DOC_MODAL:
            return {
                ...state,
                showApproveDocumentModal : action.payload
            } 
        case SET_SHOW_APPROVE_EXPERIENCE_AND_QUALIFICATION_DOC_MODAL:
            return {
                ...state,
                showExperienceAndQualificationApproveDocumentModal : action.payload
            }     
        case SET_SHOW_UPDATE_APPROVE_DOC_MODAL:
            return {
                ...state,
                showUpdateApproveDocumentModal : action.payload
            }
        case SET_CANDIDATES_BY_ADVERTISEMENT:
            return {
                ...state,
                candidatesDetailsList:action.payload
            } 
        case SET_DOCUMENTLIST_BY_CANDIDATE:
            return {
                ...state,
                documentListByCandidate:action.payload
            }
        case SET_PROFILE_INFO_BY_CANDIDATE:
            return {
                ...state,
                profileInfoByCandidate:action.payload
            } 
        case SET_VIEW_DOC_MODAL:
            return{
                ...state,
                viewDocumentFlag : action.payload
            } 
        case SET_VIEW_EXPERIENCE_AND_QUALIFICATION_MODAL:
            return{
                ...state,
                viewExperienceAndQualificationDocumentFlag : action.payload
            }     
        case SET_USER_BY_ADVERTISEMENT:
            return{
                ...state,
                userListForApproval:action.payload
            } 
        case SET_APPROVAL_DOC_LIST:
            return{
                ...state,
                approvalDocumentList:action.payload
            }
        case SET_CANCEL_REJECT_APPLICATIONS_LIST:
            return{
                ...state,
                showCancelRejectApplications:action.payload
            }
        case SET_CANCEL_REJECT_APPLICATIONDATA_BY_ADVERTISEMENT:
            return{
                ...state,
                canceRejectApplicationList:action.payload
            }
        case SET_APPROVAL_ACTION_HISTORY:
            return{
                ...state,
                approvalActionHistoryList:action.payload
            }
        case SET_ADVERTISEMENT_DETAILS:
            return{
                ...state,
                advertisementDetails :action.payload
                }            
         case ADVERTISEMENT_LIST_FOR_DOCUMENT_APPROVAL:
             return{
                 ...state,
                 advtListForDocApproval:action.payload
             }          
         case SET_ADVERTISEMENT_DETAILS_AND_DOC_APPROVAL_LIST:
             return{
                 ...state,
                 showApprovalDocList:action.payload
             }
             case SET_PROFILE_INFO_DISPLAY:
                return {
                    ...state,
                    profileInfo: action.payload
                }
            case SET_PROFILE_CREATION_LOOKUPS:
                return {
                    ...state,
                    profileCreationAllLookupData: action.payload
                }
            case SET_QUALIFICATION_TYPES:
                return {
                    ...state,
                    qualificationTypes: action.payload
                }
            case SET_APPLICATION_DETAILS:
                return {
                    ...state,
                    applicationDetails: action.payload
                }
            case SET_PROFILE_DETAILS:
                return {
                    ...state,
                    profileDetails: action.payload
                }
            case GET_ADDITIONAL_QUESTIONS_DATA:
                return {
                    ...state,
                    additionalQuestions: action.payload
                }
            case GET_ADDITIONAL_ANSWERS_DATA:
                return {
                    ...state,
                    additionalAnswers: action.payload
                }
            case SET_SCRUTINY_REPORT_DETAILS:
                return {
                    ...state,
                    scrutinyReportData:action.payload
                }
            case SET_GET_POST_NAMES_DATA:
                return {
                    ...state,
                    postNamesData:action.payload
                }
            case SET_SHOW_SCRUTINY_REPORT_DETAILS:
                return {
                    ...state,
                    showDocumentScrutinyTable : action.payload
                } 
            case SET_EXPERIENCE_AND_QUALIFICATION_APPROVAL_ACTION_HISTORY:
                return{
                    ...state,
                    experienceAndQualificationApprovalActionHistoryList:action.payload
                }
            case SET_GET_ALL_ACTIVE_ADVERTISEMENT:
                return{
                    ...state,
                    allActiveAdvertisements: action.payload
                }
            case SET_YEAR:
                return{
                ...state,
                yearList:action.payload
                }
       default:
           return state;
   }
}